import { useEffect, useState } from 'react';
import { Fingerprint } from 'lucide-react';
import { isNative } from '@/native/capacitorShell';
import {
  isBiometricEnabled, setBiometricEnabled, getBiometryInfo, verifyBiometric,
  clearBackgrounded, RELOCK_AFTER_MS,
} from '@/native/biometricLock';

// Renders only inside the mobile app — the web has no biometric hardware API.
export const BiometricSettingCard = () => {
  const [info, setInfo] = useState({ available: false, label: 'Biometric unlock' });
  const [enabled, setEnabled] = useState(isBiometricEnabled());
  const [error, setError] = useState('');

  useEffect(() => { if (isNative) getBiometryInfo().then(setInfo); }, []);

  if (!isNative || !info.available) return null;

  const toggle = async () => {
    setError('');
    if (enabled) {
      setBiometricEnabled(false);
      setEnabled(false);
      return;
    }
    try {
      await verifyBiometric(`Enable ${info.label} for Numuv`);
      setBiometricEnabled(true);
      clearBackgrounded();
      setEnabled(true);
    } catch (_) {
      setError('Could not verify. Biometric unlock stays off.');
    }
  };

  return (
    <div
      className="bg-white dark:bg-[#111114] border border-slate-200 dark:border-zinc-800 rounded-xl p-5"
      data-testid="biometric-setting-card"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-emerald-500/10 flex items-center justify-center shrink-0">
          <Fingerprint className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
        </div>
        <div className="flex-1">
          <h3 className="text-slate-900 dark:text-white font-medium">{info.label}</h3>
          <p className="text-slate-500 dark:text-zinc-500 text-sm mt-0.5">
            Reopen Numuv with {info.label} instead of your password. You&apos;ll only be asked
            after the app has been closed for more than {Math.round(RELOCK_AFTER_MS / 60000)} minutes.
          </p>
          {error && <p className="text-red-500 text-xs mt-2" data-testid="biometric-setting-error">{error}</p>}
        </div>
        <button
          onClick={toggle}
          className={`shrink-0 px-4 py-2 rounded-lg text-sm font-medium ${
            enabled
              ? 'bg-emerald-600 text-white'
              : 'bg-slate-100 dark:bg-zinc-900 text-slate-700 dark:text-zinc-300'
          }`}
          data-testid="biometric-setting-toggle"
        >
          {enabled ? 'On' : 'Enable'}
        </button>
      </div>
    </div>
  );
};

export default BiometricSettingCard;
